// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cv-form-container .formDiv {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  cursor: text;
  border-radius: 4px;
  background-color: #fff;
  transition: all 125ms cubic-bezier(0.42, 0, 0.58, 1) 0ms;
  height: 56px;
  width: 100%;
  position: relative;
  border: 1px solid #E1E1E1;
  border-radius: 6px;
  margin: 0px;
}

.cv-form-container .formDiv label {
  position: absolute;
  top: 18px;
  left: 0;
  color: grey;
  pointer-events: none;
  transition: all 0.3s ease;
  text-indent: 10px;
  line-height: 22px;
  font-size: 17px;
}

.cv-form-container .formDiv input {
  height: 100%;
  width: 100%;
  padding: 2px;
  border: none;
  font-size: 0.9rem;
  text-indent: 10px;
  box-sizing: border-box;
  border-radius: 6px;
  padding-top: 16px;
  background-color: transparent;
}

.cv-form-container .formDiv input:focus {
  border: none;
  outline: none;
}

.cv-form-container .formDiv label.hasValue,
.cv-form-container .formDiv:focus-within label {
  transform: translateY(-10px);
  font-size: 12px;
  line-height: 16px;
}

.cv-form-container .formDiv.hasError {
  box-shadow: inset 0 0 0 1px rgba(204, 48, 68, 0.3);
  background-color: rgba(204, 48, 68, 0.07);
}

.cv-form-container .formDiv .react-datepicker__input-container {
  position: unset;
}

.floating-wrapper {
  position: relative;
}

.floating-wrapper > label {
  position: absolute;
  z-index: 1;
  top: 18px;
  left: 12px;
  color: grey;
  transition: all 0.3s;
}

.floating-wrapper > label.hasValue, .floating-wrapper:has(.control-input.focus) > label {
  transform: translateY(-10px);
  font-size: 12px;
}

.floating-wrapper > label.hasValue, .floating-wrapper:has(.control-textarea.focus) > label {
  transform: translateY(-10px);
  font-size: 12px;
}

.floating-wrapper .control-textarea {
  box-shadow: inset 0 0 0 1px #E1E1E1;
}
.floating-wrapper .control-textarea.has-error {
  box-shadow: inset 0 0 0 1px rgba(204, 48, 68, 0.3);
  background-color: rgba(204, 48, 68, 0.07);
}

.floating-wrapper .control-textarea textarea {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 15px;
}

.floating-wrapper .control-textarea.has-value, .floating-wrapper .control-textarea.focus {
  padding-top: 20px;
  font-size: 0.9rem;
}`, "",{"version":3,"sources":["webpack://./styles.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,wDAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;AACJ;;AAGA;EACI,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,oBAAA;EACA,yBAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;AAAJ;;AAGA;EACI,YAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,6BAAA;AAAJ;;AAGA;EACI,YAAA;EACA,aAAA;AAAJ;;AAGA;;EAEI,4BAAA;EACA,eAAA;EACA,iBAAA;AAAJ;;AAGA;EACI,kDAAA;EACA,yCAAA;AAAJ;;AAGA;EACI,eAAA;AAAJ;;AAEA;EACI,kBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,oBAAA;AACJ;;AAEA;EACI,4BAAA;EACA,eAAA;AACJ;;AACA;EACI,4BAAA;EACA,eAAA;AAEJ;;AAAA;EACI,mCAAA;AAGJ;AAFI;EACI,kDAAA;EACA,yCAAA;AAIR;;AADA;EACI,0CAAA;EACA,eAAA;AAIJ;;AAFA;EACI,iBAAA;EACA,iBAAA;AAKJ","sourcesContent":[".cv-form-container .formDiv {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-items: center;\n  cursor: text;\n  border-radius: 4px;\n  background-color: #fff;\n  transition: all 125ms cubic-bezier(0.42, 0, 0.58, 1) 0ms;\n  height: 56px;\n  width: 100%;\n  position: relative;\n  border: 1px solid #E1E1E1;\n  border-radius: 6px;\n  margin: 0px;\n}\n\n.cv-form-container .formDiv label {\n  position: absolute;\n  top: 18px;\n  left: 0;\n  color: grey;\n  pointer-events: none;\n  transition: all 0.3s ease;\n  text-indent: 10px;\n  line-height: 22px;\n  font-size: 17px;\n}\n\n.cv-form-container .formDiv input {\n  height: 100%;\n  width: 100%;\n  padding: 2px;\n  border: none;\n  font-size: 0.9rem;\n  text-indent: 10px;\n  box-sizing: border-box;\n  border-radius: 6px;\n  padding-top: 16px;\n  background-color: transparent;\n}\n\n.cv-form-container .formDiv input:focus {\n  border: none;\n  outline: none;\n}\n\n.cv-form-container .formDiv label.hasValue,\n.cv-form-container .formDiv:focus-within label {\n  transform: translateY(-10px);\n  font-size: 12px;\n  line-height: 16px;\n}\n\n.cv-form-container .formDiv.hasError {\n  box-shadow: inset 0 0 0 1px rgba(204, 48, 68, 0.3);\n  background-color: rgba(204, 48, 68, 0.07);\n}\n\n.cv-form-container .formDiv .react-datepicker__input-container {\n  position: unset;\n}\n\n.floating-wrapper {\n  position: relative;\n}\n\n.floating-wrapper > label {\n  position: absolute;\n  z-index: 1;\n  top: 18px;\n  left: 12px;\n  color: grey;\n  transition: all 0.3s;\n}\n\n.floating-wrapper > label.hasValue, .floating-wrapper:has(.control-input.focus) > label {\n  transform: translateY(-10px);\n  font-size: 12px;\n}\n\n.floating-wrapper > label.hasValue, .floating-wrapper:has(.control-textarea.focus) > label {\n  transform: translateY(-10px);\n  font-size: 12px;\n}\n\n.floating-wrapper .control-textarea {\n  box-shadow: inset 0 0 0 1px #E1E1E1;\n}\n.floating-wrapper .control-textarea.has-error {\n  box-shadow: inset 0 0 0 1px rgba(204, 48, 68, 0.3);\n  background-color: rgba(204, 48, 68, 0.07);\n}\n\n.floating-wrapper .control-textarea textarea {\n  font-family: \"Source Sans Pro\", sans-serif;\n  font-size: 15px;\n}\n\n.floating-wrapper .control-textarea.has-value, .floating-wrapper .control-textarea.focus {\n  padding-top: 20px;\n  font-size: 0.9rem;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
